@if (wizard()) {
  <div
    class="header-wrapper wizard-header"
    [class.opaque]="!transparent()"
    [class.noLabel]="noLabelWizard()"
    [class.overlap]="overlap()"
    [class.mobile]="isMobile()"
    [class.desktop]="!isMobile()"
    [class.show-next]="isMobile() && currentstep() > 3"
  >
    <div class="header-content">
      @for (bubble of wizardsteps(); track i; let i = $index) {
        @if (i > 0) {
          <span
            class="wizardline"
            [class.greenLine]="i + start() <= currentstep()"
          ></span>
        }
        <div
          class="wizardbubble"
          [class.errorStep]="
            i + start() === currentstep() && currentstepError()
          "
          [class.currentStep]="
            i + start() === currentstep() && !currentstepError()
          "
          [class.pastStep]="i + start() < currentstep()"
          tabindex="0"
          role="button"
          (click)="onWizardButtonClick(i)"
          (keyup.enter)="onWizardButtonClick(i)"
        >
          <span class="wizardnumber">
            @if (i + start() === currentstep() && !currentstepError()) {
              {{ i + 1 + start() }}
            }
            @if (i + start() === currentstep() && currentstepError()) {
              <i
                nz-icon
                nzType="icons:exit"
                class="svg-icon mini-icon fillwhite"
              ></i>
            }
            @if (i + start() > currentstep()) {
              {{ i + 1 + start() }}
            }
            @if (i + start() < currentstep()) {
              <i nz-icon nzType="icons:check" class="svg-icon mini-icon"></i>
            }
          </span>

          @if (!noLabelWizard()) {
            <span class="detail-bold wizardlabel">{{ bubble }}</span>
          }
        </div>
      }
    </div>
  </div>
}
